import {
  LAYOUT_ADD,
  CALCULATE_HEIGHT,
  EDITOR_DELETE,
} from "../Constants/EditorConstants";

import { RESUME_DATA_UPDATE_SUCCESS } from "../Constants/ResumeConstants";

export const changeLayout = (data) => async (dispatch) => {
  try {
    dispatch({
      type: LAYOUT_ADD,
      payload: data,
    });
  } catch (error) {
    // dispatch({
    //   type: RESUME_DATA_UPDATE_SUCCESS,
    //   payload: {loading: false},
    // });
    dispatch({
      type: EDITOR_DELETE,
      payload:
        error.response && error.response.data
          ? error.response.data.error
          : error.message,
    });
  }
};

export const calculateHeight = (data) => async (dispatch) => {
  try {
    dispatch({
      type: CALCULATE_HEIGHT,
      payload: data,
    });
  } catch (error) {
    // dispatch({
    //   type: RESUME_DATA_UPDATE_SUCCESS,
    //   payload: {loading: false},
    // });
    dispatch({
      type: EDITOR_DELETE,
      payload:
        error.response && error.response.data
          ? error.response.data.error
          : error.message,
    });
  }
};
